import { render, staticRenderFns } from "./formpage.vue?vue&type=template&id=7fbe93d0&"
import script from "./formpage.vue?vue&type=script&lang=js&"
export * from "./formpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports